/* eslint-disable class-methods-use-this */

/* eslint-disable lines-between-class-members */
import axios from "axios";

import {API_STOCK_URL, COMMON_HEADER_CONFIG} from "src/config";

class ReportStockService {
  getAccessToken = () => localStorage.getItem("accessToken");
  userId = () => localStorage.getItem("userId");

  getReportStocks = (params = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_STOCK_URL}/report-stock`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        params: {
          per_page: 10,
          page: 1,
          ...params
        }
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateReportStock = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PUT",
        url: `${API_STOCK_URL}/report-stock/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: {state: data.state}
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateStockHoldPicklist = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_STOCK_URL}/report-stock-v2`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json",
          "x-user-id": this.userId()
        },
        data
      };
      return axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const reportStockService = new ReportStockService();

export default reportStockService;
